import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { css } from '@emotion/react';
import { getCodeStyles } from '@atlaskit/code/inline';
import { DN70, N30A } from '@atlaskit/theme/colors';
import { getTheme, themed } from '@atlaskit/theme/components';
export var codeMarkSharedStyles = function codeMarkSharedStyles(props) {
  var theme = getTheme(props);
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    .code {\n      --ds--code--bg-color: ", ";\n      ", "\n    }\n  "])), themed({
    light: "var(--ds-background-neutral, ".concat(N30A, ")"),
    dark: "var(--ds-background-neutral, ".concat(DN70, ")")
  })(props), getCodeStyles(theme));
};